import { lazy } from "react";

export const PageViewHome = lazy(() => import("./Home"));
